import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export async function createArtist(artist: string): Promise<Response> {
  const response = await fetch(`${baseUrl()}/api/v1/artists/request`, {
    method: 'POST',
    body: JSON.stringify({
      name: artist
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });
  return response;
}